<template>
  <div
    class="container"
  >
    <table class="customeTable">
      <thead class="customeTableHead">
        <tr class="customeTableHeadRow">
          <th style="width: 27%">
            {{ $t('forms.labels.wONumber') }}
          </th>
          <th style="width: 17%">
            {{ $t('forms.labels.date') }}
          </th>
          <th style="width: 15%">
            {{ $t('billing.labels.soNumber') }}
          </th>
          <th style="width: 20%">
            {{ $t('siteDashboard.numRequest') }}
          </th>
          <th style="width: 20%" />
        </tr>
      </thead>
      <tbody class="customeTableContent">
        <tr
          v-for="(item, index) in labWorkOrder"
          :key="index"
          class="customeTableContentRow"
        >
          <td>{{ item.wONumber }}</td>
          <td>{{ item.wOdate }}</td>
          <td>{{ item.soNumber }}</td>
          <td>{{ item.analysisRequestCount }}</td>
          <td>
            <div
              v-if="item"
              class="edirect-icon"
              @click="goTo(item)"
            >
              <v-icon
                color="#154fe3"
              >
                mdi-arrow-top-right
              </v-icon>
              <span>go</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Pagination -->
    <UnbilledWorkOrderFooter
      :currentPage="pagination.currentPage"
      :totalPageCount="pagination.totalPageCount"
      isFirstTab
      @changePage="changePage($event)"
    />
  </div>
</template>

<script>

import labBillingStatus from '@/constants/labBillingStatus';
import UnbilledWorkOrderFooter from '@/views/sites/siteDashboard/components/UnbilledWorkOrders/UnbilledWorkOrderFooter.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'LabWorkOrder',
    components: { UnbilledWorkOrderFooter },
    props: {
        workOrderType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            labWorkOrder: [],
            pagination: {},
            queryParams: {
                page: 1,
                perpage: 4,
                completionStatus: [labBillingStatus.APPROVED, labBillingStatus.SENT, labBillingStatus.IN_PROGRESS].join(','),
                billable: true,
                notInvoiced: true,
            },
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    watch: {
        workOrderType: {
            handler(val) {
                if (val === 'tab1') {
                    this.changePage(1);
                }
            },
        },
    },
    mounted() {
        this.getLabWorkOrder();
        this.changePage(1);
    },

    methods: {
        async getLabWorkOrder() {
            this.queryParams = {
                ...this.queryParams,
                sites: [this.site.id],
            };
            const cleanQueryParams = this.$utils.removeEmptyNullOrUndefined(this.queryParams, true);
            const { data } = await this.$rq.getBillingLab(cleanQueryParams);
            this.labWorkOrder = data.workOrders.map(workOrder => ({
                ...workOrder,
                wONumber: workOrder.woNumber,
                wOdate: workOrder.startDate ? this.$options.filters.formatDate(workOrder.startDate, 'L') : null,
                soNumber: workOrder.soNumber || null,
                analysisRequestCount: workOrder?.analysisRequests?.length || 0,
            }));
            this.pagination = data.pagination;
        },

        goTo(item) {
            this.$router.push({
                name: 'labWorkOrderView',
                params: {
                    labWorkOrderId: item.id,
                    clientId: item.client.id,
                    siteId: item.site.id,
                },
            });
        },

        changePage(page) {
            if (this.queryParams.page < 1 || this.queryParams.page > this.queryParams.totalPageCount) return;
            this.pagination.currentPage = page;
            document.getElementById('prev').disabled = this.pagination.currentPage === 1;
            document.getElementById('next').disabled = this.pagination.currentPage === this.pagination.totalPageCount;
            document.getElementsByClassName('page').forEach((button, index) => {
                if (index + 1 === this.pagination.currentPage) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
            this.queryParams.page = page;
            this.getLabWorkOrder();
        },
    },
};


</script>


<style lang="scss" scoped>
@import "@/assets/styles/components/unbilliedWoStyle";
</style>
